import { Action } from '@ngrx/store';
import { Persona } from '../../models';

export enum PersonaActionTypes {

    LOAD = '[Persona] Load',
    LOAD_SUCCESS = '[Persona] Load Success',
    PERSONA_ACTION_FAIL = '[Persona] Action Fail',
    SET_PERSONA = '[Persona] Set',
    GET_PERSONA = '[Persona] Get',
    INIT_PERSONA = '[Persona] Init',
    INIT_PERSONA_SUCCESS = '[Persona] Init success',
    SET_SKIP_SELECTION = '[Persona] Set skip selection'
}

export class Load implements Action {
    readonly type = PersonaActionTypes.LOAD;

    constructor() {
    }
}

export class LoadSuccess implements Action {
    readonly type = PersonaActionTypes.LOAD_SUCCESS;

    constructor(public items: Persona[]) {
    }
}

export class PersonaActionFail implements Action {
    readonly type = PersonaActionTypes.PERSONA_ACTION_FAIL;

    constructor(public error?: any) {
    }
}

export class SetPersona implements Action {
    readonly type = PersonaActionTypes.SET_PERSONA;

    constructor(public persona: Persona) {
    }
}

export class GetPersona implements Action {
    readonly type = PersonaActionTypes.GET_PERSONA;

    constructor() {
    }
}

export class InitPersona implements Action {
    readonly type = PersonaActionTypes.INIT_PERSONA;

    constructor() {
    }
}

export class InitPersonaSuccess implements Action {
    readonly type = PersonaActionTypes.INIT_PERSONA_SUCCESS;

    constructor(public persona: Persona) {
    }
}
export class SetSkipSelection implements Action {
    readonly type = PersonaActionTypes.SET_SKIP_SELECTION;

    constructor(public value: boolean) {
    }
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type PersonaActions =
  | Load
  | LoadSuccess
  | PersonaActionFail
  | SetPersona
  | InitPersona
  | InitPersonaSuccess
  | GetPersona
  | SetSkipSelection;
